<script lang="ts">
	import { getAuthContext } from '../NewsHeader/AuthDialogs/utils/getAuthContext/getAuthContext';
	import { lockBodyScroll } from '#lib/utils/lockBodyScroll/lockBodyScroll.js';
	import { DialogOverlay } from '$global/components/Dialog/DialogOverlay';

	const { showOverlay } = getAuthContext();

	// The news dialogs paint their backdrop here rather than in the shared
	// Dialog, so this is also where the page behind them is stopped from
	// scrolling. The lock is released by the effect's cleanup when the last
	// dialog closes.
	$effect(() => {
		if ($showOverlay) {
			return lockBodyScroll();
		}
	});
</script>

{#if $showOverlay}
	<DialogOverlay />
{/if}
